import { InfoTooltip } from '../../../components/InfoTooltip';
import type { AccumulatorDisplayValues } from '../../../stores/useAccumulatorStore';

/**
 * Member-facing compliance copy (DAED-40). Shown for SDC members in place of a
 * maximum value, because SDC plans carry multiple tier-specific maximums that a
 * single cell cannot represent. Do not reword.
 */
export const SDC_MAXIMUM_GUIDANCE = 'Please refer to your benefit plan documentation for this amount.';

export interface AccumulatorTableProps {
  memberName: string;
  values: AccumulatorDisplayValues;
  /** Adds the guidance icon to the two Maximum column headers. */
  isSdc?: boolean;
}

/**
 * Two-row (INDIVIDUAL / FAMILY) accumulator table.
 *
 * Markup mirrors www/app/views/accumulator.html so the existing Bootstrap styling
 * applies unchanged. The literal `$ ` prefix is rendered on every amount cell,
 * including dashed ones — a suppressed amount displays as `$ -`, as it does today.
 */
export function AccumulatorTable({ memberName, values, isSdc = false }: AccumulatorTableProps) {
  return (
    <div className="panel table-responsive">
      <table className="table">
        <tbody>
          <tr>
            <th>Member</th>
            <th>Type</th>
            <th>Amount to Deductible</th>
            <th>
              Maximum Deductible
              {isSdc && (
                <InfoTooltip
                  label="More information about Maximum Deductible"
                  text={SDC_MAXIMUM_GUIDANCE}
                />
              )}
            </th>
            <th>Amount to Out of Pocket</th>
            <th>
              Maximum Out of Pocket
              {isSdc && (
                <InfoTooltip
                  label="More information about Maximum Out of Pocket"
                  text={SDC_MAXIMUM_GUIDANCE}
                />
              )}
            </th>
          </tr>
          <tr>
            <td>{memberName.toUpperCase()}</td>
            <td>INDIVIDUAL</td>
            <td>$ {values.deductibleYTD}</td>
            <td>$ {values.deductible}</td>
            <td>$ {values.outOfPocketYTD}</td>
            <td>$ {values.maxOutOfPocket}</td>
          </tr>
          <tr>
            <td />
            <td>FAMILY</td>
            <td>$ {values.familyDeductibleYTD}</td>
            <td>$ {values.familyDeductible}</td>
            <td>$ {values.familyOutOfPocketYTD}</td>
            <td>$ {values.familyMaxOutOfPocket}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
